import React from 'react';
import { safeSessionStorage } from './storage';

/**
 * 带有自动重试和发版 404 刷新机制的 React.lazy 包装器
 * 解决前端发版后用户旧页面加载新 chunk 报错 ChunkLoadError 导致白屏的问题
 */
export function lazyWithRetry<T extends React.ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
  name?: string
): React.LazyExoticComponent<T> {
  return React.lazy(async () => {
    const pageHasBeenForceRefreshedKey = `page_refresh_${name || 'chunk'}`;
    try {
      return await componentImport();
    } catch (error: any) {
      console.error(`[lazyWithRetry] 加载模块 ${name || ''} 失败:`, error);

      // 检查是否是 ChunkLoadError 或网络加载失败
      const isChunkError =
        error?.name === 'ChunkLoadError' ||
        error?.message?.includes('Loading chunk') ||
        error?.message?.includes('Failed to fetch') ||
        error?.message?.includes('Importing a module script failed');

      const hasRefreshed = safeSessionStorage.getItem(pageHasBeenForceRefreshedKey);

      if (isChunkError && !hasRefreshed) {
        // 设置标记防止死循环刷新
        safeSessionStorage.setItem(pageHasBeenForceRefreshedKey, 'true');
        console.warn(`[lazyWithRetry] 检测到 Chunk 加载失败，自动刷新页面以获取最新资源...`);
        window.location.reload();
        // 返回一个永远 pending 的 promise 等待刷新
        return new Promise<{ default: T }>(() => {});
      }

      // 如果已经刷新过一次依然失败，抛出错误由 ErrorBoundary 捕获
      throw error;
    }
  });
}
